/** @format */

import { defineStore, StoreDefinition } from 'pinia';
import { getMenu, useGlobalStoreWithOut } from '@power/runtime-vue3';
// import { ElMessageBox } from 'element-plus';
import { store } from '@/store';
import { useRouterStoreWithOut } from '@/store/modules/router';
import { menuUtil } from '@/utils/menu';

interface MenuState {
	displayMenus: any;
	menus: any;
	menusRes: any;
	name?: string;
	url?: string;
	isAddAlias?: boolean;
}

export const useMenuStore: StoreDefinition = defineStore({
	id: 'p-components-menu',
	state: (): MenuState => ({
		displayMenus: [],
		menus: [],
		menusRes: [],
		name: undefined,
		url: undefined,
		isAddAlias: false,
	}),
	getters: {},
	actions: {
		setMenus(menus) {
			this.menus = menus;
		},
		setDisplayMenus(displayMenus) {
			this.displayMenus = displayMenus;
			//console.log('displayMenus', displayMenus);
		},
		setName(name) {
			this.name = name;
		},
		setUrl(url) {
			this.url = url;
		},
		setAddAlias(flag) {
			this.isAddAlias = flag;
		},
		/** 初始化菜单数据 */
		async getMenuInfo() {
			const globalStore = useGlobalStoreWithOut();
			if (!globalStore.token) {
				return;
			}
			let params = {};
			if (this.url) {
				params = {
					url: this.url,
				};
			} else if (globalStore.curSystem?.id) {
				params = {
					systemId: globalStore.curSystem?.id,
				};
			} else {
				//console.log('正在使用本地菜单');
				return;
			}
			const res = await getMenu(params);

			this.setMenusByRes(res);
		},

		/** 初始化菜单数据通过接口返回的res */
		async setMenusByRes(res = []) {
			this.menusRes = res;
			// 过滤无效的菜单
			const data = menuUtil.dealDataMenu(res);
			const filterMenu = menuUtil.filterMenu(data);
			// 显示的菜单
			// const displayMenus = menuUtil.getDisplayMenus(filterMenu);
			// 初始化菜单
			const menus = menuUtil.transformToTreeAndLevelFormat(JSON.parse(JSON.stringify(filterMenu)));

			// 过滤菜单
			// const filterOnlyMenu = menuUtil.filterOnlyMenu(data);
			this.menus = menus || [];
			// console.log('displayMenus', displayMenus);
			// console.log('menus', menus);
		},

		/** 初始化基础数据 */
		async initData() {},

		/** 方法一：内部系统通过系统名称来获取菜单数据进行菜单渲染 */
		async initCurSidebarByInnerSystemName(name) {
			const globalStore = useGlobalStoreWithOut();
			await globalStore.setCurSystem(name);
			const menuStore = useMenuStoreWithOut();
			await menuStore.setName(name);
			await menuStore.setUrl(null);
			await menuStore.getMenuInfo();
		},

		/** 方法二：通过url来获取菜单数据进行菜单渲染 */
		async initCurSidebarByUrl(url: string, name?: string) {
			const globalStore = useGlobalStoreWithOut();
			await globalStore.setCurSystem(name);
			const menuStore = useMenuStoreWithOut();
			await menuStore.setName(name);
			await menuStore.setUrl(url);
			await menuStore.getMenuInfo();
		},

		/** 方法三：通过本地配置来获取菜单数据进行菜单渲染 */
		async initCurSidebarByLocalConfig(name?: string) {
			const globalStore = useGlobalStoreWithOut();
			await globalStore.setCurSystem(name);
			const menuStore = useMenuStoreWithOut();
			await menuStore.setName(name);
			await menuStore.setUrl(null);
			await menuStore.setMenus([]);
		},

		/** 更新菜单数据后需要将要显示的菜单和相关路由都初始化，需要在router初始化完成之后调用这个方法 */
		async initCurSidebarDisplayMenusAndDynamicRouter() {
			const menuStore = useMenuStoreWithOut();
			const routerStore = useRouterStoreWithOut();
			const generatorResult = await routerStore.generatorDynamicRouter(menuStore.menus);
			menuStore.setDisplayMenus(generatorResult.menus);
		},
	},
});

// 在组件setup函数外使用
export function useMenuStoreWithOut(): any {
	return useMenuStore(store);
}
